<template>
  <section v-loading.fullscreen.lock="loading" class="noticeDto">
    <div v-if="dtoObj">
      <com-dto-data1 :list="libraryInfo.obj.basics" :obj="dtoObj" />
      <div class="noticeDto-content">
        <el-scrollbar wrap-style="overflow-x: hidden;">
          <div class="coontent" v-html="dtoObj.content" />
        </el-scrollbar>
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comDtoData1 from './comDtoData1.vue'
export default {
  components: {
    comDtoData1
  },
  data() {
    return {
      libraryInfo: mock.library.contrast.viewInfo,
      libraryInit: mock.library.contrast.init,
      dtoObj: null,
      requestParams1: {
        school_id: null
      },
      loading: false
    }
  },
  computed: {},
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    async init() {
      this.requestParams1.school_id = this.$route.query.id
      this.dtoObj = await this.libraryInit.article(this.requestParams1)
      // this.loading = false;
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>
<style lang='scss' scoped>
.noticeDto {
  @include fun-layout(1);
  > div {
    height: 100%;
    width: 66%;
    margin: 0 auto;
  }
  &-content {
    height: calc(100% - 106px);
    @include fun-layout(2);
    margin-top: 20px;
    padding: 20px;
  }
}
.coontent {
  padding-bottom: 50px;
}
</style>
